import {
  AGENT_STATUS_CLOSED,
  AGENT_STATUS_RELEASED,
  MAX_AGENT_CLOSE_AMOUNT,
} from 'common/constants'
import {createAction, handleActions} from 'redux-actions'
import {fetchReferral} from './referral'
import {isEmbedded} from 'common/util/features'
import {loadError, loadFinish, loadStart} from 'common/redux/root'
import {replace} from 'react-router-redux'
import {
  selectCloseDateValid,
  selectPropertyTourQuestionsData,
  selectRescheduledTourDate,
  selectRescheduledTourTime,
  selectStatusClosedFields
} from 'manager/selectors/referral_status_selectors'
import {
  selectFormattedPropertyInquiryTourDate,
  selectPropertyInquiryLocation,
} from 'manager/selectors/referral_selectors'

import client from 'common/util/http'
import format from 'date-fns/format'
import _ from 'lodash'
import {isAfter, parse} from 'date-fns'
import {
  fetchSettlementProviderSearchConfig,
  searchQualiaSettlementAgencies,
  setSettlementProviderSearchNameFilter
} from "manager/redux/settlement_provider_search"

const RESET = 'referral_status/RESET'
const LOAD = 'referral_status/LOAD'

const SET_IS_INTERESTED_IN_TOUR = 'referral_status/SET_IS_INTERESTED_IN_TOUR'
const SET_IS_REQUESTED_TOUR_COMPLETED = 'referral_status/SET_IS_REQUESTED_TOUR_COMPLETED'
const SET_IS_REQUESTED_TOUR_SCHEDULED = 'referral_status/SET_IS_REQUESTED_TOUR_SCHEDULED'
const SET_IS_TOUR_COMPLETED = 'referral_status/SET_IS_TOUR_COMPLETED'
const SET_IS_TOUR_RESCHEDULED = 'referral_status/SET_IS_TOUR_RESCHEDULED'
const SET_REQUESTED_TOUR_SCHEDULED_DATE = 'referral_status/SET_REQUESTED_TOUR_SCHEDULED_DATE'
const SET_REQUESTED_TOUR_SCHEDULED_TIME = 'referral_status/SET_REQUESTED_TOUR_SCHEDULED_TIME'
const SET_RESCHEDULED_TOUR_DATE = 'referral_status/SET_RESCHEDULED_TOUR_DATE'
const SET_RESCHEDULED_TOUR_TIME = 'referral_status/SET_RESCHEDULED_TOUR_TIME'

const SET_TOUR_COMPLETED_NOTE = 'referral_status/ADD_COMPLETED_NOTE'
const SET_TOUR_RESCHEDULED_NOTE = 'referral_status/ADD_RESCHEDULED_NOTE'
const TOGGLE_TOUR_COMPLETE_OPID = 'referral_status/TOGGLE_TOUR_COMPLETE_OPID'

const MARK_FIELD_BLURRED = 'referral_status/MARK_FIELD_BLURRED'
const RESET_BLURRED_FIELDS = 'referral_status/RESET_BLURRED_FIELDS'

const load = createAction(LOAD)
const reset = createAction(RESET)

const rescheduledTourDate = createAction(SET_RESCHEDULED_TOUR_DATE)
const rescheduledTourTime = createAction(SET_RESCHEDULED_TOUR_TIME)

export const setIsInterestedInTour = createAction(SET_IS_INTERESTED_IN_TOUR)
export const setIsRequestedTourCompleted = createAction(SET_IS_REQUESTED_TOUR_COMPLETED)
export const setIsRequestedTourScheduled = createAction(SET_IS_REQUESTED_TOUR_SCHEDULED)
export const setIsTourRescheduled = createAction(SET_IS_TOUR_RESCHEDULED)

export const setRequestedTourScheduledDate = createAction(SET_REQUESTED_TOUR_SCHEDULED_DATE)
export const setRequestedTourScheduledTime = createAction(SET_REQUESTED_TOUR_SCHEDULED_TIME)

const tourCompleted = createAction(SET_IS_TOUR_COMPLETED)
const setTourCompletedNote = createAction(SET_TOUR_COMPLETED_NOTE)
const setTourRescheduledNote = createAction(SET_TOUR_RESCHEDULED_NOTE)
export const toggleTourCompleteOpIds = createAction(TOGGLE_TOUR_COMPLETE_OPID)

export const markFieldBlurred = createAction(MARK_FIELD_BLURRED)
export const resetBlurredFields = createAction(RESET_BLURRED_FIELDS)

const defaultErrorHandler = dispatch => error => {
  dispatch(loadError(error))
  return Promise.reject(error)
}

export const setShowLastNote = showLastNote => load({ showLastNote })
export const setEditMortgageCompany = editMortgageCompany => load({ editMortgageCompany })
export const setEditTitleCompany = editTitleCompany => load({ editTitleCompany })
export const selectMortgageCompany = lender => load({ lender })
export const selectTitleCompany = settlement => load({ settlement })
export const USE_PRIOR_SELECTION = 'use-prior-selection'
export const usePriorSettlementSelection = () => load({ settlement: USE_PRIOR_SELECTION })
export const USE_NEW_SELECTION = 'use-new-selection'
export const useNewSettlementSelection = () => load({ settlement: USE_NEW_SELECTION })
export const setNewTitleCompany = settlement_new_selection_company => load({ settlement_new_selection_company })
export const setFinanceType = financeType => load({ financeType })
export const updateMortgageOptOut = (loan_opt_out_company, loan_opt_out_officer, loan_opt_out_refer, loan_opt_out_email, loan_opt_out_phone, loan_opt_out_reasons) => load({
  loan_opt_out_company, loan_opt_out_officer, loan_opt_out_refer, loan_opt_out_email, loan_opt_out_phone, loan_opt_out_reasons
})
export const updateTitleOptOut = (settlement_opt_out_company, settlement_opt_out_officer, settlement_opt_out_refer, settlement_opt_out_email, settlement_opt_out_phone, settlement_opt_out_reasons) => load({
  settlement_opt_out_company, settlement_opt_out_officer, settlement_opt_out_refer, settlement_opt_out_email, settlement_opt_out_phone, settlement_opt_out_reasons
})

export const setField = (name, value) => load({ [name]: value })

export const setIsTourCompleted = isCompleted => (dispatch, getState) => {
  dispatch(tourCompleted(isCompleted))

  if (!isCompleted) {
    return
  }

  const state = getState()
  const tourLocation = selectPropertyInquiryLocation(state)
  const formattedTourDate = selectFormattedPropertyInquiryTourDate(state)
  const { address, city, state: stateAbbreviation, zip } = tourLocation

  const note = `Completed tour of ${address}, ${city}, ${stateAbbreviation} ${zip} on ${formattedTourDate}.`
  dispatch(setTourCompletedNote(note))
}

const rescheduleTourNote = () => (dispatch, getState) => {
  const state = getState()
  const rescheduledTourDate = selectRescheduledTourDate(state)
  const rescheduledTourTime = selectRescheduledTourTime(state)
  if (!rescheduledTourDate || !rescheduledTourTime) {
    return
  }

  const tourLocation = selectPropertyInquiryLocation(state)
  const { address, city, state: stateAbbreviation, zip } = tourLocation

  const note = `Rescheduled tour of ${address}, ${city}, ${stateAbbreviation} ${zip} to ${format(rescheduledTourDate, "MMMM D")}.`
  dispatch(setTourRescheduledNote(note))
}

export const setRescheduledTourDate = date => dispatch => {
  dispatch(rescheduledTourDate(date))

  dispatch(rescheduleTourNote())
}

export const setRescheduledTourTime = time => dispatch => {
  dispatch(rescheduledTourTime(time))

  dispatch(rescheduleTourNote())
}

export const updateReleaseReason = createAction(LOAD, release_reason => ({ release_reason }))

export function updateHoldTerm(term) {
  return dispatch => {
    dispatch(load({hold_term:term}))
  }
}

export function updateNote(value) {
  value = value || ''  // Note textarea UI didn't update if 'value' was null here
  return dispatch => {
    dispatch(load({note:value}))
  }
}

export function updateOfferStatus(value) {
  return dispatch => {
    dispatch(load({offer_status:value}))
  }
}

export const checkNoteValid = ({ type, payload }) => (dispatch, getState) => {
  const {
    note,
    release_reason = _.get(getState(), ['referralState', 'release_reason'])
  } = payload

  const isNoteOptional = type === 'release' && release_reason !== 'other'
  const validNote =  !!note || isNoteOptional

  dispatch(load({ validNote }))

  return validNote
}

const checkContractValid = ({ type, payload }) => (dispatch, getState) => {
  if (type !== 'contract') {
    return true
  }

  const {
    contract_mls,
    contract_amount,
    contract_close_date,
    contract_property_address,
    contract_status,
  } = payload
  const state = getState()
  const isLease = _.get(state, ['referral', 'referral', 'is_lease'], false)
  const contractDetailsNotRequired = contract_status === 'contract-broken'

  const validContractMLS = !!contract_mls || isLease || contractDetailsNotRequired
  const validContractAmount = (contract_amount > 0 && contract_amount < MAX_AGENT_CLOSE_AMOUNT) || contractDetailsNotRequired

  const validContractCloseDate = isAfter(parse(contract_close_date), new Date()) || contractDetailsNotRequired

  const validContractPropertyAddress = !!contract_property_address || contractDetailsNotRequired

  dispatch(load({
    validContractMLS,
    validContractAmount,
    validContractCloseDate,
    validContractPropertyAddress,
    validationAttempted: true
  }))

  return validContractMLS && validContractAmount && validContractCloseDate && validContractPropertyAddress
}

const checkClosedValid = ({ type, payload }) => (dispatch, getState) => {
  if (type !== AGENT_STATUS_CLOSED) {
    return true
  }

  const {
    close_mls,
    close_amount,
    commission_amount,
    close_property_address,
  } = payload
  const state = getState()
  const isLease = _.get(state, ['referral', 'referral', 'is_lease'], false)

  const validCloseMLS = !!close_mls || isLease
  const validCloseAmount = close_amount > 0 && close_amount < MAX_AGENT_CLOSE_AMOUNT
  const validCloseDate = selectCloseDateValid(getState())
  const validCommissionAmount = commission_amount > 0 && (isLease || commission_amount < close_amount)
  const validClosePropertyAddress = !!close_property_address

  dispatch(load({
    validCloseMLS,
    validCloseAmount,
    validCloseDate,
    validCommissionAmount,
    validClosePropertyAddress,
  }))

  return validCloseMLS && validCloseAmount && validCloseDate && validCommissionAmount && validClosePropertyAddress
}

const checkReleasedValid = ({ type, payload }) => dispatch => {
  if (type !== 'release') {
    return true
  }

  const validReleaseReason = !!payload.release_reason

  dispatch(load({ validReleaseReason }))

  return validReleaseReason
}

const checkOfferStatusValid = ({ type, payload }) => (dispatch, getState) => {
  if (type !== 'offers-made') {
    return true
  }

  const state = getState()
  const isLease = _.get(state, ['referral', 'referral', 'is_lease'], false)

  const validOfferStatus = !!payload.offer_status || isLease

  dispatch(load({ validOfferStatus }))

  return validOfferStatus
}

const checkContractStatusValid = ({ type, payload }) => (dispatch, getState) => {
  if (type !== 'contract') {
    return true
  }

  const state = getState()
  const previousAgentStatus = _.get(state, ['referral', 'referral', 'agent_status'])

  const validContractStatus = previousAgentStatus != 'contract' || !!payload.contract_status

  dispatch(load({ validContractStatus }))

  return validContractStatus
}

const checkContractAmendedValid = ({ type, payload }) => (dispatch, getState) => {
  if (type !== 'contract') {
    return true
  }

  const state = getState()
  const previousAgentStatus = _.get(state, ['referral', 'referral', 'agent_status'])
  const prev_contract_mls = _.get(state, ['referral', 'referral', 'agent_contract_mls'])
  const prev_contract_property_address = _.get(state, ['referral', 'referral', 'agent_contract_property_address'])
  const prev_contract_amount = _.get(state, ['referral', 'referral', 'agent_contract_amount'])
  const prev_contract_close_date = _.get(state, ['referral', 'referral', 'agent_contract_close_date'])

  const validContractAmended = (
    payload.contract_status !== 'contract-amended' ||
    previousAgentStatus !== 'contract' ||
    payload.contract_status !== 'contract-amended' ||
    (payload.contract_close_date !== prev_contract_close_date) ||
    (payload.contract_amount !== prev_contract_amount) ||
    (payload.contract_mls !== prev_contract_mls) ||
    (payload.contract_property_address !== prev_contract_property_address)
  )

  dispatch(load({ validContractAmended }))

  return validContractAmended
}

const checkLenderValid = ({ type, payload }) => (dispatch, getState) => {
  if (type !== 'closed') {
    return true
  }

  const state = getState()
  const transaction_type = _.get(state, ['referral', 'referral', 'transaction_type'])
  const financeType = _.get(state, ['referralStatus', 'financeType'])
  const user = _.get(state, ['auth', 'user'])

  const validLender = user.admin_user ||
    transaction_type !== 'buy' ||
    financeType === 'cash' ||
    !!payload.lender

  dispatch(load({ validLender }))

  return validLender
}

const checkSettlementValid = ({ type, payload }) => (dispatch, getState) => {
  if (type !== 'closed') {
    return true
  }

  const state = getState()
  const require_settlement_at_close = _.get(state, ['referral', 'referral', 'require_settlement_at_close'])
  const admin_user = _.get(state, ['auth', 'user', 'admin_user'])
  let validSelection
  let settlement_co = payload.settlement_new_selection_company
  if (payload.settlement === USE_NEW_SELECTION){
    validSelection = settlement_co && settlement_co.name && settlement_co.name.trim().length > 0 ? true : false
  } else if(payload.settlement === USE_PRIOR_SELECTION){
    validSelection = true
  } else {
    validSelection = !!payload.settlement
  }

  const validSettlement = admin_user || !require_settlement_at_close || validSelection
  dispatch(load({ validSettlement }))

  return validSettlement
}

export const checkReferralStatusFormValid = ({ status, payload }) => dispatch => {
  const callActionCreator = actionCreator => dispatch(actionCreator({ type: status, payload }))
  const isValid = result => !!result

  return [
    checkContractValid,
    checkClosedValid,
    checkReleasedValid,
    checkOfferStatusValid,
    checkContractStatusValid,
    checkContractAmendedValid,
    checkLenderValid,
    checkSettlementValid,
  ].map(callActionCreator).every(isValid)
}

export const closeStatusDrawer = () => {
  return dispatch => {
    dispatch(replace({
      hash: window.location.hash,
      pathname: window.location.pathname,
      query: _.omit(window.location.query, 'editstatus', 'hold')
    }))

    dispatch(reset())
  }
}

export const closeAndReturnStatusDrawer = () => {
  return dispatch => {

    dispatch(replace({
      hash: '',
      pathname: '',
      query: ''
    }))

    dispatch(reset())
  }
}

export const setSelectedStatus = editstatus => dispatch => {
  dispatch(replace({
    pathname: window.location.pathname,
    hash: window.location.hash,
    query: { editstatus }
  }))
}

export const saveStatus = ({ action, status, payload, nextStatus }) => {
  return async (dispatch, getState) => {
    const state = getState()
    const hash = _.get(state, ['referral','referral', 'hash'])

    if (!dispatch(checkReferralStatusFormValid({ status, payload }))) {
      const saveStatusError = 'Form data was not valid'
      dispatch(loadError(saveStatusError))
      dispatch(load({ saveStatusError }))
      return
    }

    const tour = selectPropertyTourQuestionsData(state)
    const shouldSendDismiss = window.ReactNativeWebView && !nextStatus
    const shouldPopToReferralList = window.ReactNativeWebView && action === 'release'

    try {
      dispatch(loadStart())

      const embed = isEmbedded()
      const web_triggered = !embed

      const response = await client.post('save_referral_status', {
        data: {
          hash,
          action,
          status,
          embed,
          web_triggered,
          ...tour,
          ...payload,
        }
      })

      if (response.restored_to_active) {
        localStorage.setItem('restored_to_active', 'true')
      }

      if (action !== AGENT_STATUS_RELEASED) {
        await dispatch(fetchReferral(hash))
      }

      if (!nextStatus) {
        dispatch(closeAndReturnStatusDrawer())
      } else {
        dispatch(reset())
        dispatch(setSelectedStatus(nextStatus))
      }
    } catch (error) {
      dispatch(loadError(error))
      dispatch(load({ saveStatusError: error.message }))
    } finally {
      dispatch(loadFinish())
      if (shouldPopToReferralList) {
        window.ReactNativeWebView.postMessage('pop-to-referral-list')
        window.ReactNativeWebView.postMessage('dismiss')  // compatibility with older releases to exit web RM, they won't respond to pop
      }
      else if (shouldSendDismiss) {
        window.ReactNativeWebView.postMessage('dismiss')
      }
    }
  }
}

export const saveClosedPage1 = ({ close_mls, close_property_address, close_amount, commission_amount, close_date, currentPage }) =>
  load({ close_mls, close_property_address, close_amount, commission_amount, close_date, currentPage })

export const saveClosedPage2 = ({title_questions=null}) => async (dispatch, getState) => {
  const payload = selectStatusClosedFields(getState())
  if (title_questions) {
      payload.title_questions = title_questions
  }
  await dispatch(saveStatus({
    action: 'update',
    status: AGENT_STATUS_CLOSED,
    payload
  }))

  return _.get(getState(), ['referralStatus', 'saveStatusError'])
}

export const validateClosedPage2 = () => (dispatch, getState) => {
  const payload = selectStatusClosedFields(getState())

  return dispatch(checkReferralStatusFormValid({
    status: AGENT_STATUS_CLOSED,
    payload
  }))
}

export const fetchAssignmentTransactions = assignment_hash => {
  return async dispatch => {
    try {
      dispatch(loadStart())

      const assignment_transactions = await client.post('assignment_transactions', {
        data: {
          assignment_hash
        }
      })
      dispatch(load(assignment_transactions))

    } catch(e) {
      defaultErrorHandler(dispatch)(e)
    } finally {
      dispatch(loadFinish())
    }
  }
}

export const fetchTitleMatches = ({ payload }) => (dispatch) => {
  const {searchValue} = payload
  dispatch(setSettlementProviderSearchNameFilter(searchValue))
  dispatch(searchQualiaSettlementAgencies())
}

export const fetchSearchConfig = (hash, originAddrOverride) => (dispatch) => {
  dispatch(fetchSettlementProviderSearchConfig(hash, originAddrOverride))
}

export const updateReleaseReasonHighLevel = createAction(LOAD, releaseReasonHighLevel => ({ releaseReasonHighLevel }))

export const updateReleaseNumTimesContacted = createAction(LOAD, releaseNumTimesContacted => ({ releaseNumTimesContacted }))

const initialState = {
  addedTourCompletedNote: false,
  addedTourRescheduledNote: false,
  note: "",
  showLastNote: false,
  isInterestedInTour: null,
  isRequestedTourCompleted: null,
  isRequestedTourScheduled: null,
  isTourCompleted: null,
  isTourRescheduled: null,
  requestedTourScheduledDate: null,
  requestedTourScheduledTime: null,
  rescheduledTourDate: null,
  rescheduledTourTime: null,
  releaseReasonHighLevel: null,
  releaseNumTimesContacted: null,
  tourCompletedOpIds: [],
  blurredFields: new Set()
}

export default handleActions({
  [LOAD]: (state, { payload }) => ({ ...state, ...payload }),
  [RESET]: (state, { payload }) => ({ ...initialState }),
  [SET_IS_INTERESTED_IN_TOUR]: (state, { payload }) => ({...state, isInterestedInTour: payload}),
  [SET_IS_REQUESTED_TOUR_COMPLETED]: (state, { payload }) => ({...state, isRequestedTourCompleted: payload}),
  [SET_IS_REQUESTED_TOUR_SCHEDULED]: (state, { payload }) => ({...state, isRequestedTourScheduled: payload}),
  [SET_IS_TOUR_COMPLETED]: (state, { payload }) => ({...state, isTourCompleted: payload}),
  [SET_IS_TOUR_RESCHEDULED]: (state, { payload }) => ({...state, isTourRescheduled: payload}),
  [SET_RESCHEDULED_TOUR_DATE]: (state, { payload }) => ({...state, rescheduledTourDate: payload}),
  [SET_RESCHEDULED_TOUR_TIME]: (state, { payload }) => ({...state, rescheduledTourTime: payload}),
  [SET_REQUESTED_TOUR_SCHEDULED_DATE]: (state, { payload }) => ({...state, requestedTourScheduledDate: payload}),
  [SET_REQUESTED_TOUR_SCHEDULED_TIME]: (state, { payload }) => ({...state, requestedTourScheduledTime: payload}),
  [SET_TOUR_COMPLETED_NOTE]: (state, { payload }) => {
    if (state.addedTourCompletedNote || state.addedTourRescheduledNote) {
      return state
    }

    const note = state.note ? `${state.note}\n\n${payload}` : payload
    return {...state, note, addedTourCompletedNote: true}
  },
  [SET_TOUR_RESCHEDULED_NOTE]: (state, { payload }) => {
    if (state.addedTourCompletedNote || state.addedTourRescheduledNote) {
      return state
    }

    const note = state.note ? `${state.note}\n\n${payload}` : payload
    return {...state, note, addedTourRescheduledNote: true}
  },
  [TOGGLE_TOUR_COMPLETE_OPID]: (state, { payload }) => {
    if (!payload) {
      return state
    }

    const tourCompletedOpIds = state.tourCompletedOpIds.includes(payload) ?
      state.tourCompletedOpIds.filter(opId => opId !== payload) : [ ...state.tourCompletedOpIds, payload ]

    return { ...state, tourCompletedOpIds }
  },
  [MARK_FIELD_BLURRED]: (state, {payload}) => ({...state, blurredFields: new Set([...state.blurredFields, payload])}),
  [RESET_BLURRED_FIELDS]: (state, {payload}) => ({...state, blurredFields: new Set()}),
}, initialState)
